import { render, staticRenderFns } from "./TkTabs.vue?vue&type=template&id=0464a6ed&"
import script from "./TkTabs.vue?vue&type=script&lang=js&"
export * from "./TkTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports